import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_LOAD_COLLECTION_ITEMS_BEGIN,
  COLLECTIONS_LOAD_COLLECTION_ITEMS_SUCCESS,
  COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE,
  COLLECTIONS_LOAD_COLLECTION_ITEMS_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollectionItems(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_COLLECTION_ITEMS_BEGIN,
    });
    const {
      projectId,
      version,
      collectionName,
      limit,
      searchTerm,
      collection,
      page,
      sortField,
      sortOrder,
    } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}?${
          sortField ? `sortField=${sortField}` : ''
        }${sortOrder ? `&sortOrder=${sortOrder}` : ''}&limit=${limit}&page=${page}${
          searchTerm ? `&searchTerm=${searchTerm}` : ''
        }`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_LOAD_COLLECTION_ITEMS_SUCCESS,
              data: res.data,
              collection: args.collection,
            });
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionItemsError() {
  return {
    type: COLLECTIONS_LOAD_COLLECTION_ITEMS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_COLLECTION_ITEMS_BEGIN:
      return {
        ...state,
        loadCollectionItemsPending: true,
        loadCollectionItemsError: null,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEMS_SUCCESS:
      let newSelectedCollection = state.selectedCollection;
      if (action.collection && action.collection.collectionName) {
        newSelectedCollection = action.collection;
      }
      return {
        ...state,
        loadCollectionItemsPending: false,
        loadCollectionItemsError: null,
        selectedCollection: newSelectedCollection,
        selectedItem: null,
        items: action.data.content ? action.data.content : [],
        totalItemPages: action.data.totalPages,
        totalItems: action.data.totalItems,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE:
      return {
        ...state,
        loadCollectionItemsPending: false,
        loadCollectionItemsError: action.data.error,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEMS_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionItemsError: null,
      };

    default:
      return state;
  }
}
